<template>
    <div class="login-form">
        <div class="login-greeting">{{ $t('HI') }}</div>
        <LoginTextInput
            color="apple"
            :dark="true"
            :errors="errors"
            :label="$t('PLACEHOLDER_EMAIL')"
            @enter="submit"
            autocomplete="username"
            icon="mail"
            name="mail"
            style="margin-top: 2rem;"
            v-model.trim="mail"
        ></LoginTextInput>
        <LoginTextInput
            color="apple"
            :dark="true"
            :errors="errors"
            :label="$t('LABEL_PASS')"
            @enter="submit"
            autocomplete="password"
            icon="lock"
            name="password"
            type="password"
            v-model.trim="password"
        ></LoginTextInput>
        <div class="login-comment-action" @click="goToForgot">
            {{ $t('FORGOT_PASSWORD') }}
        </div>
        <ActionButton
            color="apple"
            :label="$t('BUTTON_LOGIN')"
            :loading="loading"
            @click="submit"
            class="login-form-button"
        />
        <div class="login-actions-row">
            <div class="login-comment">{{ $t('DONT_HAVE_ACCOUNT') }}</div>
            &nbsp;
            <div
                :style="{ color: $Utils.colors.blue, marginLeft: '0.5rem' }"
                class="login-action"
                @click="goToRegister"
            >
                {{ $t('SINGUP') }}
            </div>
        </div>
        <div class="login-actions-row" @click="closeForm">
            <span class="login-action">{{ $t('CLOSE') }}</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            mail: '',
            password: '',
            errors: new this.$Errors(),
            loading: false
        }
    },
    methods: {
        closeForm() {
            this.$emit('close')
        },
        goToRegister() {
            this.$emit('register')
        },
        goToForgot() {
            this.$store.commit('setSidebarForm', 'forgot')
        },
        submit() {
            if (this.loading) {
                return
            }
            this.errors.errors = []
            if (!this.password) {
                this.errors.set('password')
            }
            if (!this.mail) {
                this.errors.set('mail')
            }
            if (this.errors.errors.length > 0) {
                return
            }
            this.loading = true
            const data = {
                mail: this.mail,
                password: this.password
            }
            this.$api
                .post('v1/accounts/login', data)
                .then(({ data }) => {
                    data.mail = this.mail
                    data.display = data.name
                    this.setUser(data)
                    this.getBoughtItems()
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                    this.loading = false
                })
                .then(() => {
                    this.loading = false
                })
        },
        setUser(userData) {
            const supportRole = userData.roles.find(r => r.type == 'support')
            const selectedRole = supportRole ? supportRole : userData.roles[0]
            this.$api.defaults.headers.common[
                'Authorization'
            ] = `Bearer ${selectedRole.jwt}`
            this.$store.commit('setUser', userData)
        },
        getBoughtItems() {
            this.$api
                .get(`v1/marketplace/items`)
                .then(({ data }) => {
                    this.$store.commit('setBoughtItems', data)
                    this.$Notif.success('', this.$t('SIGNED_IN'))
                    this.$emit('logged')
                })
                .catch(error => {
                    this.$router.push('/')
                    this.$store.commit('resetState')
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.loading = false
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.login-form {
    width: 100%;
    min-width: 250px;
}
.login-action {
    color: $accent-apple !important;
}
.app-language {
    font-size: 0.8rem;
    text-align: center;
    margin-top: 0.25rem;
}
</style>
